
export default function useCopyright() {
    const currentYear =  new Date().getFullYear().toString();

    return `Copyright© ${currentYear}. All Rights Reserved.`;
}
